<template>
  <router-view />

  <mobile-block-screen v-if="shouldShowMobileScreen" />
  <confirm-modal />
  <offline-banner />
</template>

<script setup>
  import { useQuasar } from 'quasar'
  import { computed } from 'vue'
  import { useHead } from '@unhead/vue'

  import { isProduction } from 'src/config'
  import { useMetadata } from 'src/composables/app/system/useMetadata'

  import ConfirmModal from 'components/common/ConfirmModal.vue'
  import OfflineBanner from 'src/components/common/OfflineBanner.vue'
  import MobileBlockScreen from 'src/components/layout/MobileBlockScreen.vue'

  const $q = useQuasar()
  const shouldShowMobileScreen = computed(() => $q.screen.width < 780 && isProduction)

  const { metaTags } = useMetadata()
  useHead(() => metaTags.value)
</script>
